import { Col, Form, Row } from 'antd';
import { AButton, AInput, ContainerForm } from '../../../components';
import { MailOutlined, SaveOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useState } from 'react';
import { schemaMail } from '../schemas/yup.mail.schema';
import { useToast } from '../../../hooks/toast';
import { IMail } from '../../../shared/interfaces';
import { getMail, patchMail, postMail } from '../../../http';

const CompanyMail: React.FC = () => {
  const { addToast } = useToast();
  const [mail, setMail] = useState<IMail | null>(null);
  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [port, setPort] = useState<number>();
  const [host, setHost] = useState<string>();
  const [service, setService] = useState<string>();

  const loadconfigMail = useCallback(async () => {
    await getMail().then((data) => {
      if (data) {
        setMail(data);
        setPort(+data.port);
        setEmail(data.user);
        setHost(data.host);
        setService(data.service);
      }
    });
  }, []);

  const handleSubmit = useCallback(() => {
    schemaMail
      .validate({
        host,
        port,
        service,
        user: email,
        password,
      })
      .then(async (validated) => {
        if (mail?.id) {
          await patchMail(mail?.id, validated)
            .then((data) => {
              setMail(data);
              addToast({
                type: 'info',
                title: 'Alterado',
                description: 'Dados alterados com sucesso.',
              });
            })
            .catch((error) => {
              addToast({
                type: 'error',
                title: 'Erro',
                description: error.response.data.error ?? 'Erro ao alterar.',
              });
            });
        } else {
          await postMail(validated)
            .then((data) => {
              setMail(data);
              addToast({
                type: 'success',
                title: 'Cadastrado',
                description: 'Cadastrado com sucesso.',
              });
            })
            .catch((error) => {
              addToast({
                type: 'error',
                title: 'Erro',
                description: error.response.data.error ?? 'Erro ao cadastrar.',
              });
            });
        }
      })
      .catch((err) => {
        addToast({
          type: 'error',
          title: 'Campos em branco',
          description: err.errors[0],
        });
      });
  }, [mail, email, password, port, host, service, addToast]);

  useEffect(() => {
    loadconfigMail();
  }, []);

  return (
    <ContainerForm>
      <div style={{ width: '90%', marginBottom: 12 }}>
        <h3 style={{ marginBottom: 4 }}>
          <MailOutlined /> Configuração de e-mail
        </h3>
        <p style={{ margin: 0, color: '#6b7280' }}>
          Defina os parâmetros de envio usados pela clínica.
        </p>
      </div>
      <Form layout="vertical" style={{ width: '90%' }}>
        <Row>
          <Col span={12}>
            <Form.Item label="Email">
              <AInput
                placeholder="Informe o e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Senha">
              <AInput
                placeholder="Informe o e-mail"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item label="Host">
              <AInput
                placeholder="Informe o host (smtp)"
                value={host}
                onChange={(e) => setHost(e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Porta">
              <AInput
                placeholder="Informe a porta"
                type="number"
                value={port}
                onChange={(e) => setPort(+e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Serviço">
              <AInput
                placeholder="Informe o serviço (gmail)"
                value={service}
                onChange={(e) => setService(e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
        <AButton type="primary" onClick={handleSubmit} icon={<SaveOutlined />}>
          Salvar
        </AButton>
      </Form>
    </ContainerForm>
  );
};

export default CompanyMail;
